import {
  FETCH_USER_REQUEST,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILURE,
  FETCH_USER_PROXY_REQUEST,
  FETCH_USER_PROXY_SUCCESS,
  FETCH_USER_PROXY_FAILURE,
  FETCH_CONSENT_MESSAGE_SUCCESS,
  GRANT_CONSENT_SUCCESS,
  RESET_EXPIRED_PASSWORD_SUCCESS,
  sessionId,
  CLEAR_HR_SELECTED_EMPLOYEE,
  SET_LOGIN_MODE,
  LOGOUT_USER_SUCCESS,
  LOGOUT_USER_FAILURE,
  LOGOUT_ACTION_SESSION,
  REQUEST_LOGOUT_IDP,
  SUCCESS_LOGOUT_IDP,
  FAILURE_LOGOUT_IDP,
  REQUEST_CLEAR_SESSION,
  SUCCESS_CLEAR_SESSION,
  FAILURE_CLEAR_SESSION,
  REQUEST_AUTHORIZE_USER_SESSION,
  SUCCESS_AUTHORIZE_USER_SESSION,
  FAILURE_AUTHORIZE_USER_SESSION,
  SEND_OTP_START,
  SEND_OTP_SUCCESS,
  SEND_OTP_ERROR,
  RESEND_OTP_START,
  RESEND_OTP_SUCCESS,
  RESEND_OTP_ERROR,
  SEND_OTP_FORM_START,
  SEND_OTP_FORM_SUCCESS,
  SEND_OTP_FORM_ERROR,
  SEND_VERIFICATION_EMAIL_START,
  SEND_VERIFICATION_EMAIL_SUCCESS,
  SEND_VERIFICATION_EMAIL_ERROR,
  VERIFY_OTP_START,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_ERROR,
  GET_2FA_MOBILE_START,
  GET_2FA_MOBILE_SUCCESS,
  GET_2FA_MOBILE_ERROR,
  GET_2FA_COUNTRY_CODES_START,
  GET_2FA_COUNTRY_CODES_SUCCESS,
  GET_2FA_COUNTRY_CODES_ERROR,
  UPDATE_USER_ROLE_START,
  UPDATE_USER_ROLE_SUCCESS,
  UPDATE_USER_ROLE_ERROR,
  SET_USER_ROLE,
  SWITCH_USER_ROLE,
} from "actions/loginActions";
import { isExist, isMobileBrowser } from "cxa-utils";

const initialState = {
  isAuthenticated: false,
  user: { pendingAuthActions: [] },
  consentMessage: null,
  fetching: false,
  fetched: false,
  error: null,
  resourceId: null,
  isRegistrationSuceed: false,
  signupIdLabel: null,
  loginMode: "default", // ['oauth', 'default']
  isAuthorizeUserSession: false,
  isClearUserSession: false,
  clearUserSessionError: null,
  isLogoutIDPFetching: false,
  isLogoutIDPFetched: false,
  logoutIDPError: null,
  isAuthorizeUserSessionFetching: false,
  isAuthorizeUserSessionFetched: false,
  authorizeUserSessionError: null,
  twoFACountryCodes: [],
  twoFASettings: {},
  otp: {},
  isOTPSending: false,
  is2FAVerificationEmailSent: false,
  isOPTVerifying: false,
  twoFAEmailTokenError: null,
  verifyOTPError: null,
  selectedRole: "Employee",
};

export const GRANT_CONSENT = "GrantConsent";
export const RESET_EXPIRED_PASSWORD = "ResetExpiredPassword";
export const TWO_FA_REQUIRED = "TwoFARequired";
export const ROLE_SELECTION_REQUIRED = "RoleSelectionRequired";

const updatePendingAuthActions = val => {
  const user = JSON.parse(localStorage.getItem(sessionId));
  user.pendingAuthActions = user.pendingAuthActions.filter(item => item !== val);
  localStorage.setItem(sessionId, JSON.stringify(user));
  const isMobile = isMobileBrowser();
  if (
    !isMobile &&
    !user.hrAdmin &&
    Array.isArray(user.roles) &&
    user.roles.length > 1 &&
    user.pendingAuthActions
  ) {
    return [...user.pendingAuthActions, ROLE_SELECTION_REQUIRED];
  }
  return user.pendingAuthActions;
};

const formatCountryCode = (countryCodes = []) => {
  return countryCodes.map(item => {
    for (const key in item) {
      if (item.hasOwnProperty(key)) {
        const countryName = key.charAt(0).toUpperCase() + key.slice(1);
        return {
          value: countryName + item[key],
          label: key.charAt(0).toUpperCase() + key.slice(1) + " ( " + item[key] + " ) ",
        };
      }
    }
  });
};

const getResourceId = msgKey => {
  switch (msgKey) {
    case "ACCOUNT_LOCKED":
      return "accountLockedDescription";
    case "CREDENTIAL_WRONG":
      return "credentialWrongDescription";
    case "INVALID_ACCOUNT":
      return "invalidAccountDescription";
    default:
      return msgKey;
  }
};

export default (state = initialState, action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case REQUEST_AUTHORIZE_USER_SESSION: {
      return {
        ...state,
        isAuthorizeUserSessionFetching: true,
        isAuthorizeUserSessionFetched: false,
      };
    }

    case SUCCESS_AUTHORIZE_USER_SESSION: {
      return {
        ...state,
        isAuthorizeUserSessionFetching: false,
        isAuthorizeUserSessionFetched: true,
      };
    }

    case FAILURE_AUTHORIZE_USER_SESSION: {
      return {
        ...state,
        isAuthorizeUserSessionFetching: false,
        isAuthorizeUserSessionFetched: false,
      };
    }

    case REQUEST_CLEAR_SESSION: {
      return {
        ...state,
        isClearUserSession: false,
        clearUserSessionError: null,
      };
    }

    case SUCCESS_CLEAR_SESSION: {
      return {
        ...state,
        isClearUserSession: true,
        clearUserSessionError: null,
      };
    }

    case FAILURE_CLEAR_SESSION: {
      return {
        ...state,
        isClearUserSession: true,
        clearUserSessionError: payload,
      };
    }

    case REQUEST_LOGOUT_IDP: {
      return {
        ...state,
        isLogoutIDPFetching: true,
        isLogoutIDPFetched: false,
        logoutIDPError: null,
      };
    }

    case SUCCESS_LOGOUT_IDP: {
      return {
        ...state,
        isLogoutIDPFetching: false,
        isLogoutIDPFetched: true,
        logoutIDPError: null,
      };
    }

    case FAILURE_LOGOUT_IDP: {
      return {
        ...state,
        isLogoutIDPFetching: false,
        isLogoutIDPFetched: false,
        logoutIDPError: payload,
      };
    }

    case FETCH_USER_REQUEST:
      return { ...state, fetching: true };

    case FETCH_USER_FAILURE: {
      const { messageKey } = payload;

      return {
        ...state,
        fetching: false,
        isAuthenticated: false,
        error: payload,
        resourceId: getResourceId(messageKey),
      };
    }

    case FETCH_USER_SUCCESS: {
      const hasMultipleRoles =
        isExist(payload) &&
        !payload.hrAdmin &&
        Array.isArray(payload.roles) &&
        payload.roles.length > 1;
      const isMobile = isMobileBrowser();
      return {
        ...state,
        fetching: false,
        isAuthenticated: isExist(payload),
        fetched: true,
        error: null,

        user: {
          ...payload,
          pendingAuthActions:
            !isMobile && hasMultipleRoles && !payload.selectedRole
              ? [...payload.pendingAuthActions, ROLE_SELECTION_REQUIRED]
              : payload && payload.pendingAuthActions,
        },
      };
    }

    case FETCH_USER_PROXY_REQUEST:
      return { ...state, fetching: true };

    case FETCH_USER_PROXY_FAILURE:
      return {
        ...state,
        fetching: false,
        isAuthenticated: false,
        error: payload,
      };

    case FETCH_USER_PROXY_SUCCESS: {
      return {
        ...state,
        fetching: false,
        isAuthenticated: isExist(state.user),
        fetched: true,
      };
    }

    case FETCH_CONSENT_MESSAGE_SUCCESS:
      return { ...state, consentMessage: payload.message };

    case GRANT_CONSENT_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          pendingAuthActions: updatePendingAuthActions(GRANT_CONSENT),
        },
      };

    case RESET_EXPIRED_PASSWORD_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          pendingAuthActions: updatePendingAuthActions(RESET_EXPIRED_PASSWORD),
        },
      };

    case CLEAR_HR_SELECTED_EMPLOYEE:
      return { ...state, user: { ...state.user, employee: null } };

    case SET_LOGIN_MODE: {
      const { mode } = action;

      return {
        ...state,
        loginMode: mode,
      };
    }

    case LOGOUT_USER_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isAuthenticated: false,
      };

    case LOGOUT_USER_FAILURE:
      return {
        ...state,
        ...payload,
        fetching: false,
        isAuthenticated: false,
      };

    case LOGOUT_ACTION_SESSION:
      return {
        ...state,
        ...payload,
      };
    case GET_2FA_COUNTRY_CODES_START:
      return { ...state, error: null };
    case GET_2FA_COUNTRY_CODES_ERROR:
      return { ...state, error: action.payload.error };
    case GET_2FA_COUNTRY_CODES_SUCCESS:
      return {
        ...state,
        twoFACountryCodes: formatCountryCode(action.payload.countryCodeList),
        error: null,
      };
    case GET_2FA_MOBILE_START:
      return { ...state, twoFAEmailTokenError: null };
    case GET_2FA_MOBILE_ERROR:
      return { ...state, twoFAEmailTokenError: action.payload };
    case GET_2FA_MOBILE_SUCCESS:
      return {
        ...state,
        twoFASettings: action.payload,
        twoFAEmailTokenError: null,
      };
    case SEND_OTP_START:
      return { ...state, isOTPSending: true, error: null };
    case SEND_OTP_ERROR:
      return { ...state, isOTPSending: false, error: action.payload };
    case SEND_OTP_SUCCESS:
      return {
        ...state,
        otp: { receivedDate: new Date(), ...action.payload },
        isOTPSending: false,
        error: null,
      };
    case SEND_OTP_FORM_START:
      return { ...state, isOTPSending: true, twoFAEmailTokenError: null };
    case SEND_OTP_FORM_ERROR:
      return { ...state, isOTPSending: false, twoFAEmailTokenError: action.payload };
    case SEND_OTP_FORM_SUCCESS:
      return {
        ...state,
        otp: { receivedDate: new Date(), ...action.payload },
        isOTPSending: false,
        twoFAEmailTokenError: null,
      };
    case RESEND_OTP_START:
      return { ...state, isOTPSending: true, verifyOTPError: null };
    case RESEND_OTP_ERROR:
      return { ...state, isOTPSending: false, verifyOTPError: action.payload };
    case RESEND_OTP_SUCCESS:
      return {
        ...state,
        otp: { receivedDate: new Date(), ...action.payload },
        isOTPSending: false,
        verifyOTPError: null,
      };
    case VERIFY_OTP_START:
      return { ...state, isOPTVerifying: true, verifyOTPError: null };
    case VERIFY_OTP_ERROR:
      return { ...state, isOPTVerifying: false, verifyOTPError: action.payload };
    case VERIFY_OTP_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          pendingAuthActions: updatePendingAuthActions(TWO_FA_REQUIRED),
        },
        isOPTVerifying: false,
        verifyOTPError: null,
      };
    case SEND_VERIFICATION_EMAIL_START:
      return {
        ...state,
        is2FAVerificationEmailSent: false,
        error: null,
      };
    case SEND_VERIFICATION_EMAIL_ERROR:
      return { ...state, is2FAVerificationEmailSent: false, error: action.payload };
    case SEND_VERIFICATION_EMAIL_SUCCESS:
      return {
        ...state,
        is2FAVerificationEmailSent: true,
        error: null,
      };
    case UPDATE_USER_ROLE_START:
      return {
        ...state,
        fetching: true,
        error: null,
      };
    case UPDATE_USER_ROLE_SUCCESS:
      return {
        ...state,
        fetching: false,
        error: null,
        user: { ...payload },
      };
    case UPDATE_USER_ROLE_ERROR:
      return {
        ...state,
        fetching: false,
        error: payload,
      };
    case SET_USER_ROLE:
      return {
        ...state,
        selectedRole: payload,
      };
    case SWITCH_USER_ROLE:
      return {
        ...state,
        user: {
          ...state.user,
          pendingAuthActions:
            state.user.roles.length > 1
              ? [...state.user.pendingAuthActions, ROLE_SELECTION_REQUIRED]
              : [...state.user.pendingAuthActions],
        },
      };
    default:
      return state; // return previous state
  }
};



// WEBPACK FOOTER //
// ./reducers/loginReducer.jsx